__turbopack_context__.v({
  "heading": "styles-module__xZdzJG__heading",
  "headingContainer": "styles-module__xZdzJG__headingContainer",
  "sellingItemImage": "styles-module__xZdzJG__sellingItemImage",
  "soldOutImageContainer": "styles-module__xZdzJG__soldOutImageContainer",
});
